export default "__VITE_ASSET__e7e8a71b__"